// extracted by mini-css-extract-plugin
export default {"player":"RecordingField_player__AgaPO","upload":"RecordingField_upload__FsaxG"};